function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1B3647",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M4.333 0H.867C.388 0 0 .373 0 .833v3.334C0 4.627.388 5 .867 5c.478 0 .866-.373.866-.833v-2.5h2.6c.479 0 .867-.374.867-.834C5.2.373 4.812 0 4.333 0zM25.133 15c-.478 0-.866.373-.866.833v2.5h-2.6c-.479 0-.867.374-.867.834 0 .46.388.833.867.833h3.466c.479 0 .867-.373.867-.833v-3.334c0-.46-.388-.833-.867-.833zM25.133 0h-3.466c-.479 0-.867.373-.867.833 0 .46.388.834.867.834h2.6v2.5c0 .46.388.833.866.833.479 0 .867-.373.867-.833V.833c0-.46-.388-.833-.867-.833zM4.333 18.333h-2.6v-2.5c0-.46-.388-.833-.866-.833-.479 0-.867.373-.867.833v3.334c0 .46.388.833.867.833h3.466c.479 0 .867-.373.867-.833 0-.46-.388-.834-.867-.834zM3.467 3.333H5.2v13.333H3.467zM6.933 3.333h1.733v10H6.933zM10.4 3.333h1.733v10H10.4zM13.867 3.333H15.6v13.333h-1.733zM17.333 3.333h1.733v10h-1.733zM20.8 3.333h1.733v13.333H20.8zM6.933 15h1.733v1.667H6.933zM10.4 15h1.733v1.667H10.4zM17.333 15h1.733v1.667h-1.733z"
}));

var SvgBarcode = function SvgBarcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode.8a7f187b.svg";
export { ForwardRef as ReactComponent };